// The columns People and the person page read (data.js), in 1 place, so the tests replay exactly these
// (tests/e2e/fixtures/admin-people/record-people.sql reads the same, and admin-people.spec.js refuses any
// other). Pure: no imports. Every read is as the staff member, through row level security
// (docs/data-model.md 8.2 and 10.4.2), so what comes back is what their role may see.

// The person's own row (people_select: owner, admin, support; a host only someone with their product)
// free_account_at: the free account a replay's register page gave them (docs/replay-register-spec.md 3.2)
export const PERSON_COLUMNS = 'id, user_id, email, full_name, first_name, location, role, is_test, login_shared, last_login_at, last_login_device, last_seen_at, password_set_at, created_at, anonymised_at, merged_into_id, free_account_at'

// Their access rows (access_select: owner, admin, support; a host only their product's)
export const ACCESS_COLUMNS = 'id, product_id, cohort_id, status, source, starts_at, ends_at, ended_at, end_reason, promised_until, first_opened_at, reason, balance_due_at, payment_failed_at, suspend_on, paused_until, pause_reason, paused_by, batch_id, updated_by_person_id, updated_by_kind, created_at'

// What Stripe holds for each row, by id only (access_billing and people_billing: owner, admin)
export const BILLING_COLUMNS = 'access_id, stripe_checkout_session_id, stripe_customer_id, stripe_subscription_id, stripe_price_id, place_price_id, unpaid_invoice_id, payments_made, payments_total'
export const PEOPLE_BILLING_COLUMNS = 'person_id, stripe_customer_id'

// The catalogue with what the person page needs beyond the shell's read: certificates, the terms line
export const CATALOGUE_COLUMNS = 'id, slug, path, name, type, access_kind, state, look, moved_in, certificate_on, terms_line, term_months, release_basis, sort_order'

// Every product's intakes, for Grant a product and Change cohort
export const COHORT_COLUMNS = 'id, product_id, name, kind, starts_on, ends_on, number, sort_order'

// A free item held back from them, still current (free_holds: owner, admin, support read)
export const HOLD_COLUMNS = 'id, product_id, reason, held_at, held_by'

// Staff notes (owner, admin), and their authors' names
export const NOTE_COLUMNS = 'id, body, author_id, created_at'
export const NAME_COLUMNS = 'id, full_name, first_name'

// What they've done with the free things (activity: owner, admin, support), the free webinar replays
// they've watched (replay_progress with watched_at set, which the database sets: owner and admin read
// it, support can't), and the webinars named in either
export const ACTIVITY_COLUMNS = 'product_id, webinar_id, kind, source, occurred_at'
export const REPLAY_COLUMNS = 'webinar_id, watched_at'
export const WEBINAR_COLUMNS = 'id, product_id, title, starts_at'

// A 1-2-1 client's spaces (owner, admin)
export const SPACE_COLUMNS = 'id, product_id, opened_at, ended_at, booking_url'

// The addresses they've changed from (owner, admin), their open data requests (owner, admin), and a
// host's products (owner only changes them)
export const PREVIOUS_EMAIL_COLUMNS = 'id, email, changed_at, changed_by_kind'
export const REQUEST_COLUMNS = 'id, kind, status, requested_at'
export const SCOPE_COLUMNS = 'person_id, product_id'

// A live course's Start here (Profit On Your Terms): its switched-on rows and their screens, and the
// person's progress on them (owner, admin and support read them; data-model 10.6.2), for Progress's
// "Start here 1 of 2. Marketing setup not started." (AdminPerson.dc.html). Their own lists, so no
// other screen's read of the same tables answers them.
export const START_HERE_STEP_COLUMNS = 'id, product_id, step_key, step_type, title, parent_step_id, sort_order'
export const START_HERE_PROGRESS_COLUMNS = 'step_id, done_at, updated_at'

// A member's Start here answers under that line (Adam, 7 Oct, the batch's question 2): the switched-on
// screens with their config (the gate's 3 lines, the second channel's options, each assignment's label
// and lines), then the person's answers on the screens that hold a tick or a choice. Owner, admin and
// support at 2-step login read them (data-model 10.6.6); a host reads none, so the page doesn't ask.
// Their own lists, so the reads for Progress's line answer as before.
export const START_HERE_ANSWER_SCREEN_COLUMNS = 'id, product_id, step_key, title, parent_step_id, sort_order, config'
export const START_HERE_ANSWER_COLUMNS = 'step_id, answers, done_at'

// The People list's page size, and Export CSV's
export const PAGE = 50
export const CSV_PAGE = 200
